import React from "react";

const Pagination = ({ page, hasNext, hasPrev }) => {
  return (
    <div className="pagination">
      {hasPrev && (
        <a href={hasPrev} className="page-button">Previous</a>
      )}
      <span>Page {page}</span>
      {hasNext && (
        <a href={hasNext} className="page-button">Next</a>
      )}
    </div>
  );
};

export default Pagination;
